import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxSummaryComponent, PhxSummaryLabelComponent, PhxSummaryValueComponent } from './phx-summary.component';
import { PhxSummaryRowComponent } from './phx-summary-row.component';
import { PhxSkeletonModule } from './../skeleton/phx-skeleton.module';

@NgModule({
  declarations: [
    PhxSummaryComponent,
    PhxSummaryRowComponent,
    PhxSummaryValueComponent,
    PhxSummaryLabelComponent
  ],
  imports: [
    CommonModule,
    PhxSkeletonModule,
  ],
  exports: [
    PhxSummaryComponent,
    PhxSummaryRowComponent,
    PhxSummaryValueComponent,
    PhxSummaryLabelComponent
  ]
})
export class PhxSummaryModule { }
